import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import StickyTable from "../../components/common/StickyTable";
import {
  MEMBERSHIP_EXPIRY_AND_RENEWAL_REPORTS_LIST,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, NOPAGINATE } from "../../constant/constant";
import { NoDataFound, Pagination, hasRole } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Select from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import {
  styleExcelHeaderRow,
  styleExcelTitleRow,
} from "../../utils/excelStyles";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Link } from "react-router-dom";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

import { pdfHeaderStyles } from "../../constant/theme";
const MembershipExpiryRenewalReportsList = () => {
  const { hasPermission } = usePermission();
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filter, setFilter] = useState({});
  const applyFilter = (next) => {
    setPage(1);
    setFilter(next);
  };

  const [loading, setLoading] = useState(true);
  const [btnExcelDisabled, setBtnExcelDisabled] = useState(false);
  const [btnPdfDisabled, setBtnPdfDisabled] = useState(false);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [showClearDueBtn, setShowClearDueBtn] = useState(false);
  const [showClearJoiningBtn, setShowClearJoiningBtn] = useState(false);
  const [showClearCreationBtn, setShowClearCreationBtn] = useState(false);
  const [showClearRenewalBtn, setShowClearRenewalBtn] = useState(false);
  const refFlatpickrDue = useRef(null);
  const refFlatpickrJoining = useRef(null);
  const refFlatpickrCreation = useRef(null);
  const refFlatpickrRenewal = useRef(null); // Renewal Date Filter

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));

  //excel export start
  const columns = [{ header: "Sl.No.", key: "sno" }];
  columns.push({ header: "Member ID", key: "member_id" });
  columns.push({ header: "Member Name", key: "name" });
  columns.push({ header: "Email", key: "email" });
  columns.push({ header: "Mobile Number", key: "mobile_number" });
  // if (hasRole([1])) { columns.push({ header: "Country", key: "country_name" }); }
  // if (hasRole([1, 6])) { columns.push({ header: "State", key: "state_name" }); }
  if (hasRole([1, 6, 7])) {
    columns.push({ header: "Region", key: "region_name" });
  }
  if (hasRole([1, 6, 7, 2])) {
    columns.push({ header: "Chapter", key: "chapter_name" });
  }
  columns.push({ header: "Date of Joining", key: "date_of_joining" });
  columns.push({ header: "Date of Creation", key: "date_of_creation" });
  columns.push({ header: "Membership Due Date", key: "membership_due_date" });
  columns.push({ header: "Days Left / Overdue", key: "days_left_or_overdue" });
  columns.push({ header: "Membership Status", key: "membership_status_text" });
  columns.push({ header: "Renewal Status", key: "renewal_status" });
  columns.push({ header: "Last Renewal Date", key: "last_renewal_date" });

  //excel title starts
  const {
    membership_due_from,
    membership_due_to,
    joining_date_from,
    joining_date_to,
    renewal_date_from,
    renewal_date_to,
    creation_date_from,
    creation_date_to,
  } = filter;
  let workSheetName = `Membership Expiry & Renewal Reports`;
  if (membership_due_from && membership_due_to) {
    if (membership_due_from === membership_due_to) {
      workSheetName += ` - Due (${moment(membership_due_from).format("DD/MM/YYYY")})`; // single date
    } else {
      workSheetName += ` - Due (${moment(membership_due_from).format("DD/MM/YYYY")} to ${moment(membership_due_to).format("DD/MM/YYYY")})`;
    }
  } else if (joining_date_from && joining_date_to) {
    if (joining_date_from === joining_date_to) {
      workSheetName += ` - Joining (${moment(joining_date_from).format("DD/MM/YYYY")})`; // single date
    } else {
      workSheetName += ` - Joining (${moment(joining_date_from).format("DD/MM/YYYY")} to ${moment(joining_date_to).format("DD/MM/YYYY")})`;
    }
  } else if (creation_date_from && creation_date_to) {
    if (creation_date_from === creation_date_to) {
      workSheetName += ` - Created (${moment(creation_date_from).format("DD/MM/YYYY")})`;
    } else {
      workSheetName += ` - Created (${moment(creation_date_from).format("DD/MM/YYYY")} to ${moment(creation_date_to).format("DD/MM/YYYY")})`;
    }
  } else if (renewal_date_from && renewal_date_to) {
    if (renewal_date_from === renewal_date_to) {
      workSheetName += ` - Renewal (${moment(renewal_date_from).format("DD/MM/YYYY")})`; // single date
    } else {
      workSheetName += ` - Renewal (${moment(renewal_date_from).format("DD/MM/YYYY")} to ${moment(renewal_date_to).format("DD/MM/YYYY")})`;
    }
  } else {
    workSheetName += ``;
  }
  //excel title end
  const title = workSheetName;
  const fileName = "Membership_Expiry_Renewal_Reports";

  const workbook = new Excel.Workbook();

  const exportAsExcel = async () => {
    try {
      const worksheet = workbook.addWorksheet(fileName.substring(0, 31)); // excel sheet name limit
      worksheet.columns = columns;

      worksheet.insertRow(1, []);

      const totalCols = columns.length || 1;
      const lastColLetter = String.fromCharCode(64 + totalCols);
      let endCell = lastColLetter;
      if (totalCols > 26) {
        endCell =
          String.fromCharCode(64 + Math.floor((totalCols - 1) / 26)) +
          String.fromCharCode(64 + ((totalCols - 1) % 26) + 1);
      }

      worksheet.mergeCells(`A1:${endCell}1`);
      const titleCell = worksheet.getCell("A1");
      titleCell.value = title || "Membership Expiry Renewal Reports";
      styleExcelTitleRow(worksheet.getRow(1), totalCols);

      const headerRow = worksheet.getRow(2);
      styleExcelHeaderRow(headerRow, totalCols);

      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 15;
        column.alignment = { horizontal: "center" };
      });
      setBtnExcelDisabled(true);
      await axios
        .get(MEMBERSHIP_EXPIRY_AND_RENEWAL_REPORTS_LIST, {
          params: {
            type: NOPAGINATE,
            isAdmin: 1,
            ...filter,
          },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            const excelData = response.data.data.members;

            if (excelData.length < 1) {
              toast.error("No data found!.");
              return;
            }

            excelData.forEach((singleData) => {
              worksheet.addRow({
                ...singleData,
                membership_status_text:
                  singleData.membership_status === 1 ? "Active" : "Inactive",
              });
            });

            worksheet.eachRow({ includeEmpty: false }, (row) => {
              const currentCell = row._cells;
              currentCell.forEach((singleCell) => {
                const cellAddress = singleCell._address;
                worksheet.getCell(cellAddress).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            });

            const buf = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
          }
        })
        .finally(() => {
          setBtnExcelDisabled(false);
        });
    } catch (error) {
      toast.error(error.message);
    } finally {
      workbook.removeWorksheet(fileName.substring(0, 31));
    }
  };

  const exportAsPDF = async () => {
    try {
      const doc = new jsPDF("landscape");

      const headers = ["Sl.No.", "ID", "Name", "Email", "Mobile"];
      // if (hasRole([1])) { headers.push('Country'); }
      // if (hasRole([1, 6])) { headers.push('State'); }
      if (hasRole([1, 6, 7])) {
        headers.push("Region");
      }
      if (hasRole([1, 6, 7, 2])) {
        headers.push("Chapter");
      }
      headers.push("Joining");
      headers.push("Created");
      headers.push("Due Date");
      headers.push("Days Left");
      headers.push("Status");
      headers.push("Renewal");
      headers.push("Last Renewal");

      setBtnPdfDisabled(true);
      await axios
        .get(MEMBERSHIP_EXPIRY_AND_RENEWAL_REPORTS_LIST, {
          params: {
            type: NOPAGINATE,
            isAdmin: 1,
            ...filter,
          },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            if (response.data.data.members.length < 1) {
              toast.error("No data found!.");
              return;
            }

            const pdfData = response.data.data.members.map((data) => {
              let pData = [
                data.sno,
                data.member_id,
                data.name,
                data.email,
                data.mobile_number,
              ];
              // if (hasRole([1])) { pData.push(data.country_name); }
              // if (hasRole([1, 6])) { pData.push(data.state_name); }
              if (hasRole([1, 6, 7])) {
                pData.push(data.region_name);
              }
              if (hasRole([1, 6, 7, 2])) {
                pData.push(data.chapter_name);
              }
              pData.push(data.date_of_joining);
              pData.push(data.date_of_creation);
              pData.push(data.membership_due_date);
              pData.push(data.days_left_or_overdue);
              pData.push(data.membership_status === 1 ? "Active" : "Inactive");
              pData.push(data.renewal_status);
              pData.push(data.last_renewal_date);
              return pData;
            });

            let pdfTitle = title;
            const textWidth =
              (doc.getStringUnitWidth(pdfTitle) * doc.internal.getFontSize()) /
              doc.internal.scaleFactor;
            const textOffset = (doc.internal.pageSize.width - textWidth) / 2;
            doc.text(pdfTitle, textOffset, 10);

            doc.autoTable({
              head: [headers],
              body: pdfData,
              margin: { top: 20, right: 10, bottom: 20, left: 10 },
              startY: 20,
              headerStyles: {
                ...pdfHeaderStyles,
                textColor: [255, 255, 255],
                fontSize: 8,
              },
              styles: { lineWidth: 0.1, fontSize: 8 },
            });
            doc.save(`${fileName}.pdf`);
          }
        })
        .finally(() => {
          setBtnPdfDisabled(false);
        });
    } catch (error) {
      toast.error(error.message);
    }
  };

  const expiryTypeOptions = [
    { value: "expiring_in_7", label: "Expiring in 7 days" },
    { value: "expiring_in_15", label: "Expiring in 15 days" },
    { value: "expiring_in_30", label: "Expiring in 30 days" },
    { value: "already_expired", label: "Already expired" },
    { value: "expired_more_than_30", label: "Expired more than 30 days" },
    { value: "active", label: "Active Members" },
    { value: "inactive", label: "Inactive Members" },
  ];

  const handleDateRangeDueClear = () => {
    setShowClearDueBtn(false);
    if (refFlatpickrDue.current) refFlatpickrDue.current.flatpickr.setDate([]);
    applyFilter({
      ...filter,
      membership_due_from: "",
      membership_due_to: "",
    });
  };

  const handleDateRangeJoiningClear = () => {
    setShowClearJoiningBtn(false);
    if (refFlatpickrJoining.current)
      refFlatpickrJoining.current.flatpickr.setDate([]);
    applyFilter({
      ...filter,
      joining_date_from: "",
      joining_date_to: "",
    });
  };

  const handleDateRangeCreationClear = () => {
    setShowClearCreationBtn(false);
    if (refFlatpickrCreation.current)
      refFlatpickrCreation.current.flatpickr.setDate([]);
    applyFilter({
      ...filter,
      creation_date_from: "",
      creation_date_to: "",
    });
  };

  const handleDateRangeRenewalClear = () => {
    setShowClearRenewalBtn(false);
    if (refFlatpickrRenewal.current)
      refFlatpickrRenewal.current.flatpickr.setDate([]);
    applyFilter({
      ...filter,
      renewal_date_from: "",
      renewal_date_to: "",
    });
  };

  useEffect(() => {
    let isMounted = true;
    const fetchReports = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          MEMBERSHIP_EXPIRY_AND_RENEWAL_REPORTS_LIST,
          {
            params: {
              type: PAGINATE,
              page: page,
              perPage: perPage,
              isAdmin: 1,
              ...filter,
            },
          },
        );
        if (response.status === 200 && response.data.success && isMounted) {
          const responseData = response.data.data;
          setData(responseData.members || []);
          setPaginator({
            prev: responseData.prev != null && responseData.prev !== "",
            next: responseData.next != null && responseData.next !== "",
            total: responseData.total,
            current: responseData.current_page,
            last: responseData.last_page,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchReports();
    return () => {
      isMounted = false;
    };
  }, [page, filter, perPage]);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        if (isMounted) setCountryOptions(countryResponse.data.data);

        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: { ...filter },
        });
        if (isMounted) setStateOptions(stateResponse.data.data);

        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: { ...filter },
        });
        if (isMounted) setRegionOptions(regionResponse.data.data);

        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: { ...filter },
        });
        if (isMounted) setChapterOptions(chapterResponse.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, [filter.country_id, filter.state_id, filter.region_id, filter.chapter_id]);

  const handleCalendarDueClick = () => {
    if (refFlatpickrDue.current) {
      refFlatpickrDue.current.flatpickr.open();
    }
  };

  const handleCalendarJoiningClick = () => {
    if (refFlatpickrJoining.current) {
      refFlatpickrJoining.current.flatpickr.open();
    }
  };

  const handleCalendarCreationClick = () => {
    if (refFlatpickrCreation.current) {
      refFlatpickrCreation.current.flatpickr.open();
    }
  };

  const handleCalendarRenewalClick = () => {
    if (refFlatpickrRenewal.current) {
      refFlatpickrRenewal.current.flatpickr.open();
    }
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">
                Membership Expiry & Renewal Reports
              </h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span>Reports</span>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">
                    Membership Expiry Renewal Reports List
                  </span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission(
                  "reports-membership-expiry-renewal-list-export",
                ) && (
                  <>
                    <button
                      disabled={btnExcelDisabled}
                      type="button"
                      onClick={exportAsExcel}
                      className="btn rounded-pill btn-primary excel-btn ibutton"
                    >
                      <span className="tf-icons bx bxs-spreadsheet"></span>
                      &nbsp; Excel
                    </button>
                    <button
                      disabled={btnPdfDisabled}
                      type="button"
                      onClick={exportAsPDF}
                      className="btn rounded-pill btn-primary pdf-btn ibutton"
                    >
                      <span className="tf-icons bx bxs-file-pdf"></span>&nbsp;
                      Download PDF
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          <div className="container-fluid f_containter">
            <div className="row mb-2 gx-3">
              {hasRole([1]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      applyFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      applyFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="region_id">
                    Region
                  </label>
                  <Select
                    ref={selectRegionRef}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="region_id"
                    isClearable
                    options={regionOptions}
                    onChange={(selected) => {
                      handleChapterClear();
                      applyFilter({
                        ...filter,
                        region_id: selected?.value,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="chapter_id">
                    Chapter
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectChapterRef}
                    name="chapter_id"
                    isClearable
                    options={chapterOptions}
                    onChange={(selected) =>
                      applyFilter({ ...filter, chapter_id: selected?.value })
                    }
                  />
                </div>
              )}

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="search_query">
                  Search
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name, Email, Mobile, Member ID"
                  onChange={(e) =>
                    applyFilter({ ...filter, search_query: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="expiry_type">
                  Expiry Type
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="expiry_type"
                  isClearable
                  options={expiryTypeOptions}
                  onChange={(selected) =>
                    applyFilter({ ...filter, expiry_type: selected?.value })
                  }
                />
              </div>

              <div className="col-md-3 mb-3 dateRangeDiv">
                <label className="form-label" htmlFor="date_range">
                  Membership Due Date Filter
                </label>
                <div className="datepicker_wrapper">
                  <div className="datepicker">
                    <Flatpickr
                      ref={refFlatpickrDue}
                      className="form-control"
                      options={{
                        mode: "range",
                        dateFormat: "Y-m-d",
                        onChange: (selected) => {
                          setShowClearDueBtn(true);
                          if (
                            selected[0] !== undefined &&
                            selected[1] !== undefined &&
                            selected[1] !== undefined &&
                            selected[1] !== ""
                          ) {
                            applyFilter({
                              ...filter,
                              membership_due_from: selected[0]
                                ? moment(selected[0]).format("YYYY-MM-DD")
                                : "",
                              membership_due_to: selected[1]
                                ? moment(selected[1]).format("YYYY-MM-DD")
                                : "",
                            });
                          }
                        },
                        onClose: (selected) => {
                          if (!selected[1]) {
                            setShowClearDueBtn(false);
                          }
                        },
                      }}
                      placeholder="Due Date Range"
                    />
                    {showClearDueBtn && (
                      <button
                        className="border-0 clearDateRangeBtn"
                        data-bs-toggle="tooltip"
                        data-bs-offset="0,4"
                        data-bs-placement="top"
                        data-bs-html="true"
                        title="Clear"
                        data-bs-original-title="Clear"
                        onClick={handleDateRangeDueClear}
                      >
                        <i className="bx bx-x"></i>
                      </button>
                    )}
                  </div>
                  <div className="cal_icon" onClick={handleCalendarDueClick}>
                    <span className="input-group-text calendar-icon"></span>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mb-3 dateRangeDiv">
                <label className="form-label" htmlFor="date_range_joining">
                  Date of Joining Filter
                </label>
                <div className="datepicker_wrapper">
                  <div className="datepicker">
                    <Flatpickr
                      ref={refFlatpickrJoining}
                      className="form-control"
                      options={{
                        mode: "range",
                        dateFormat: "Y-m-d",
                        onChange: (selected) => {
                          setShowClearJoiningBtn(true);
                          if (
                            selected[0] !== undefined &&
                            selected[1] !== undefined &&
                            selected[1] !== undefined &&
                            selected[1] !== ""
                          ) {
                            applyFilter({
                              ...filter,
                              joining_date_from: selected[0]
                                ? moment(selected[0]).format("YYYY-MM-DD")
                                : "",
                              joining_date_to: selected[1]
                                ? moment(selected[1]).format("YYYY-MM-DD")
                                : "",
                            });
                          }
                        },
                        onClose: (selected) => {
                          if (!selected[1]) {
                            setShowClearJoiningBtn(false);
                          }
                        },
                      }}
                      placeholder="Joining Date Range"
                    />
                    {showClearJoiningBtn && (
                      <button
                        className="border-0 clearDateRangeBtn"
                        data-bs-toggle="tooltip"
                        data-bs-offset="0,4"
                        data-bs-placement="top"
                        data-bs-html="true"
                        title="Clear"
                        data-bs-original-title="Clear"
                        onClick={handleDateRangeJoiningClear}
                      >
                        <i className="bx bx-x"></i>
                      </button>
                    )}
                  </div>
                  <div
                    className="cal_icon"
                    onClick={handleCalendarJoiningClick}
                  >
                    <span className="input-group-text calendar-icon"></span>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label" htmlFor="date_range_creation">
                    Date of Creation Filter
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickrCreation}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearCreationBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              applyFilter({
                                ...filter,
                                creation_date_from: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                creation_date_to: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearCreationBtn(false);
                            }
                          },
                        }}
                        placeholder="Creation Date Range"
                      />
                      {showClearCreationBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeCreationClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div
                      className="cal_icon"
                      onClick={handleCalendarCreationClick}
                    >
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="mt-3 dateRangeDiv">
                  <label className="form-label" htmlFor="last_renewal_date">
                    Last Renewal Date Filter
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickrRenewal}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearRenewalBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              applyFilter({
                                ...filter,
                                renewal_date_from: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                renewal_date_to: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearRenewalBtn(false);
                            }
                          },
                        }}
                        placeholder="Renewal Date Range"
                      />
                      {showClearRenewalBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeRenewalClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div
                      className="cal_icon"
                      onClick={handleCalendarRenewalClick}
                    >
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}

          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Member ID</th>
                  <th>Member Name</th>
                  <th>Email</th>
                  <th>Mobile Number</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  <th>Date of Joining</th>
                  <th>Date of Creation</th>
                  <th>Membership Due Date</th>
                  <th>Days Left / Days Overdue</th>
                  <th>Membership Status</th>
                  <th>Renewal Status</th>
                  <th>Last Renewal Date</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="16" />
                ) : data.length > 0 ? (
                  data.map((member, i) => (
                    <tr key={i}>
                      <td>{member?.sno}</td>
                      <td>{member?.member_id}</td>
                      <td>{member?.name}</td>
                      <td>{member?.email}</td>
                      <td>{member?.mobile_number}</td>
                      {hasRole([1]) && <td>{member?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{member?.state_name || "Tamil Nadu"}</td>}
                      {hasRole([1, 6, 7]) && <td>{member?.region_name}</td>}
                      {hasRole([1, 6, 7, 2]) && <td>{member?.chapter_name}</td>}
                      <td>{member?.date_of_joining}</td>
                      <td>{member?.date_of_creation}</td>
                      <td>{member?.membership_due_date}</td>
                      <td>
                        {member?.days_left_or_overdue &&
                        member?.days_left_or_overdue.includes("overdue") ? (
                          <span className="badge bg-label-danger">
                            {member?.days_left_or_overdue}
                          </span>
                        ) : (
                          <span className="badge bg-label-success">
                            {member?.days_left_or_overdue}
                          </span>
                        )}
                      </td>
                      <td>
                        {member?.membership_status === 1 ? (
                          <span className="badge bg-label-success">Active</span>
                        ) : (
                          <span className="badge bg-label-danger">
                            Inactive
                          </span>
                        )}
                      </td>
                      <td>
                        {member?.renewal_status === "Upcoming" && (
                          <span className="badge bg-label-warning">
                            Upcoming
                          </span>
                        )}
                        {member?.renewal_status === "Expired" && (
                          <span className="badge bg-label-danger">Expired</span>
                        )}
                        {member?.renewal_status === "Renewed" && (
                          <span className="badge bg-label-success">
                            Renewed
                          </span>
                        )}
                      </td>
                      <td>{member?.last_renewal_date || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="16" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MembershipExpiryRenewalReportsList;
